// src/context/CarSearchContext.jsx
import React, { createContext, useContext, useState, useMemo } from "react";

const CarSearchContext = createContext(null);

export function CarSearchProvider({ children }) {
  const [searchData, setSearchData] = useState({
    category: "",                // "normal" | "premium"
    carType: "",                 // "Hatchback" | "Sedan" | "SUV"
    pickupLocation: "",
    destinations: [],            // array of mid-stops
    finalDestination: "",
    radius: 20,
    pickupDate: "",              // "YYYY-MM-DD"
    pickupTime: "",              // "hh:mm AM/PM" (UI) — will convert to 24h for API
    releaseDate: "",
    releaseTime: "",
    totalDistance: 0,            // computed km across legs
    durationHours: 0,            // computed hours (pickup -> drop)
  });

  const updateSearchData = (patch) =>
    setSearchData((prev) => ({ ...prev, ...patch }));

  const value = useMemo(() => ({ searchData, updateSearchData }), [searchData]);
  return (
    <CarSearchContext.Provider value={value}>
      {children}
    </CarSearchContext.Provider>
  );
}

export function useCarSearch() {
  const ctx = useContext(CarSearchContext);
  if (!ctx) throw new Error("useCarSearch must be used within CarSearchProvider");
  return ctx;
}
